/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An independent guide to PdfCraft, ArtCraft's free, open-source PDF editor (github.com/storytold/pdfcraft): download it for Windows, Mac or Linux, try it online, and compare it with Adobe Acrobat.`)
};

const zh_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 PdfCraft 的独立第三方指南。PdfCraft 是 ArtCraft 团队开发的免费开源 PDF 编辑器（github.com/storytold/pdfcraft）：下载 Windows、Mac、Linux 版本，在线试用，并与 Adobe Acrobat 对比。`)
};

/**
* | output |
* | --- |
* | "An independent guide to PdfCraft, ArtCraft's free, open-source PDF editor (github.com/storytold/pdfcraft): download it for Windows, Mac or Linux, try it onli..." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_description(inputs)
	return zh_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }